import React from 'react'
import { RemoveUserPermissionsFlowProvider } from './context/RemoveUserPermissionsFlowProvider'
import { RemoveUserPermissionsFlowMain } from './components/RemoveUserPermissionsFlowMain'
import { useUserPermissionsWorkflowsContextValue } from '../../context/UserPermissionsWorkflowsProvider'

export const RemoveUserPermissionsFlow = () => {
  const { removeUserPermissionsFlow } =
    useUserPermissionsWorkflowsContextValue()

  if (!removeUserPermissionsFlow.target) {
    return null
  }

  return (
    <RemoveUserPermissionsFlowProvider>
      <RemoveUserPermissionsFlowMain
        target={removeUserPermissionsFlow.target}
      />
    </RemoveUserPermissionsFlowProvider>
  )
}
